import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { SidebarModule } from 'ng-sidebar';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BlockUIModule } from 'ng-block-ui';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { CommonModule } from "@angular/common";

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { HeaderComponent } from './components/shared/header/header.component';
import { CreditDaysPipe } from './pipes/credit-days.pipe';
import { ReportsComponent } from './components/reports/reports.component';
import { PrintReportComponent } from './components/print-report/print-report.component';
import { HttpErrorInterceptor } from './services/error-interceptor';
import { FileManagerComponent } from './components/file-manager/file-manager.component';
import { BinnacleComponent } from './components/binnacle/binnacle.component';
import { UploadsComponent } from './components/uploads/uploads.component';
import { UsersComponent } from './components/users/users.component';
import { UsersAssignsComponent } from './components/users-assigns/users-assigns.component';
import { SettingsComponent } from './components/settings/settings.component';
import { ProgressComponent } from './components/progress/progress.component';
import { DndDirective } from './directives/dnd.directive';
import { LoginComponent } from './components/login/login.component';
import { RequestInterceptorService } from './services/request-interceptor.service';
import { CompanyComponent } from './components/company/company.component';
import { ApplicationComponent } from './components/application/application.component';
import { PopoutService } from './services/popout.service';
import { ConnectionsComponent } from './components/connections/connections.component';
import { ReportUsersComponent } from './components/report-users/report-users.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HeaderComponent,
    CreditDaysPipe,
    ReportsComponent,
    PrintReportComponent,
    FileManagerComponent,
    BinnacleComponent,
    UploadsComponent,
    UsersComponent,
    UsersAssignsComponent,
    SettingsComponent,
    ProgressComponent,
    DndDirective,
    LoginComponent,
    CompanyComponent,
    ApplicationComponent,
    ConnectionsComponent,
    ReportUsersComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    SidebarModule.forRoot(),
    NgbModule,
    HttpClientModule,
    BlockUIModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    DragDropModule,
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestInterceptorService,
      multi: true,
    },
    PopoutService,
    NgbActiveModal
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
